(() => {
  if (window.__ttStepsTickerReady) return;
  window.__ttStepsTickerReady = true;
  const instances = new Map();

  function init(root = document) {
    const tickers = [...root.querySelectorAll('.steps__ticker')];
    if (root.matches?.('.steps__ticker')) tickers.unshift(root);
    tickers.forEach(ticker => {
      if (instances.has(ticker)) return;
      const className = `ticker-js-${ticker.dataset.tickerId}`;
      const container = [...ticker.getElementsByClassName(className)][0];
      // The current theme uses a CSS marquee here. Only initialize Swiper
      // when its actual wrapper and slides exist; leave CSS marquees intact.
      const wrapper = container && [...container.children].find(child => child.classList.contains('swiper-wrapper'));
      if (!wrapper || !wrapper.querySelector('.swiper-slide') || typeof Swiper !== 'function') return;
      if (container.swiper && !container.swiper.destroyed) return;
      const seconds = Number(ticker.dataset.tickerSpeed);
      const swiper = new Swiper(container, {
        slidesPerView: 'auto',
        speed: Number.isFinite(seconds) && seconds > 0 ? seconds * 1000 : 25000,
        initialSlide: 0,
        loop: true,
        loopedSlides: 50,
        allowTouchMove: false,
        waitForTransition: false,
        watchSlidesProgress: false,
        autoplay: { delay: 0, disableOnInteraction: false }
      });
      instances.set(ticker, swiper);
      ticker.classList.add('slider_started');
    });
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [ticker, swiper] of instances) {
      if (ticker === event.target || event.target.contains(ticker)) {
        if (!swiper.destroyed) swiper.destroy(true, true);
        ticker.classList.remove('slider_started');
        instances.delete(ticker);
      }
    }
  });
  document.addEventListener('visibilitychange', () => {
    for (const swiper of instances.values()) {
      if (swiper.destroyed) continue;
      if (document.hidden) swiper.autoplay?.stop();
      else {
        swiper.update();
        swiper.autoplay?.start();
      }
    }
    if (!document.hidden) init();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
